import TaskIndex from "./js/TaskIndex.jsx";

const components = [
    TaskIndex
];

export default function (app) {
    components.forEach(com => app.component(com.name, com));
};